import { Typography } from 'antd'
import React from 'react'
import * as locCon from "../LocalConstants"
import { isNullOrUndefinedOrEmpty } from '../community-hats-js-library/utils/generalFunctions'


const globalTextStyles = {
    textAlign: "center",
}

const { Text } = Typography;

function CustomText({ type, ...props }) {

    let { style, ...otherProps } = props
    if (isNullOrUndefinedOrEmpty(style))
        style = {}

    switch (type) {
        case locCon.MODULE_TITLE_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                fontSize: "2.7vh",
                fontWeight: 'bold',
                ...style
            }}
                {...otherProps} />)
        case locCon.SECTION_TITLE_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                fontSize: "2.5vh",
                fontWeight: 'bold',
                ...style
            }}
                {...otherProps} />)
        case locCon.INSTRUCTIONS_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                fontSize: "2vh",
                ...style
            }}
                {...otherProps} />)
        case locCon.DANGER_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                color: "var(--primary-color-2)",
                fontSize: "2vh",
                marginBottom: "2vh",
                ...style
            }}
                {...otherProps} />)
        case locCon.ELEMENT_TITLE_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                fontSize: "2.3vh",
                fontWeight: 'bold',
                ...style
            }}
                {...otherProps} />)
        case locCon.INFO_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                fontSize: "1.8vh",
                ...style
            }}
                {...otherProps} />)
        case locCon.SUCCESS_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                fontSize: "2vh",
                color: "var(--primary-color-3)",
                marginBottom: "2vh",
                ...style
            }}
                {...otherProps} />)
        case locCon.OPTION_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                fontSize: "2vh",
                ...style
            }}
                {...otherProps} />)
        case locCon.DISABLED_OPTION_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                fontSize: "2vh",
                ...style
            }}
                {...otherProps} />)

        case locCon.ELEMENT_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                fontSize: "2vh",
                color: "var(--primary-color-3)",
                ...style
            }}
                {...otherProps} />)

        case locCon.DEFAULT_INFO_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                fontSize: "2vh",
                ...style
            }}
                {...otherProps} />)

        case locCon.LONG_TEXT:
            return (<Text style={{
                ...globalTextStyles,
                fontSize: "2.2vh",
                color: "var(--primary-color-3)",
                ...style
            }}
                {...otherProps} />)


        default:
            return (<Text  {...otherProps} />)
    }


}

export default CustomText